<template>
  <div>
    <b-row>
      <b-col class="px-3">
        <h2>Which service you prefer ?</h2>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="p-3" cols="6" v-for="(x, index) in service_options" :key="index">
        <div class="p-3 sg-badge-selection" :class="{ selected: service === x._id }" style="height: 100%;" @click="setService(x._id)">
          <h4>
            {{ x.sgms_service_type_id.service_name }}
          </h4>
          <p class="text-left">
            {{ x.sgms_service_type_id.description.join(' ') }}
          </p>
          <h4 class="text-right mb-0">
            {{ x.currency }} {{ x.price }}
          </h4>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'Order_ModalService',
  props: ['service', 'service_options'],
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    setService: function (newService) {
      this.$emit('setService', newService)
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.sg-badge-selection {
  background-color: #dddddd;
  border: 3px solid #dddddd;
  border-radius: 5px;
  cursor: pointer;

  padding: 10px;
  font-size: 18px;
  text-align: center;
}
.sg-badge-selection.selected {
  border: 3px solid #919dbd;
  background-color: #c8cede;
}
.selected_temp,
.sg-badge-selection:hover {
  border: 3px solid #233c7c;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/ModalService/ModalService.vue